import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a built-in show/hide toggle (eye icon).
 * Drop-in replacement for a `<input type="password" />` — accepts any extra props (className,
 * placeholder, value, onChange, autoComplete, required, etc.) and forwards them to the input.
 *
 * Visual rules:
 *  - Eye icon sits inside the input on the right
 *  - Click toggles between `password` and `text`
 *  - Right padding is auto-added to make room for the icon
 *  - Inherits whatever color/border styling the parent passes
 */
export const PasswordInput = React.forwardRef(function PasswordInput(
  { className = "", testIdToggle = "password-toggle", ...rest },
  ref
) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input
        ref={ref}
        type={visible ? "text" : "password"}
        className={`${className} pr-11`}
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={testIdToggle}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 rounded-md text-white/40 hover:text-white/80 hover:bg-white/5 transition-colors"
      >
        {visible ? <EyeOff className="w-4 h-4" strokeWidth={1.8} /> : <Eye className="w-4 h-4" strokeWidth={1.8} />}
      </button>
    </div>
  );
});
